import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=6ccb42ea&scoped=true"
import script from "./ModelList.vue?vue&type=script&lang=js"
export * from "./ModelList.vue?vue&type=script&lang=js"
import style0 from "./ModelList.vue?vue&type=style&index=0&id=6ccb42ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb42ea",
  null
  
)

export default component.exports